<script>
import CreateRehabModal from "@/components/widgets/rehabilitation/add.vue";
import DetailRehabModal from "@/components/widgets/rehabilitation/show.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import { filter } from "@/helpers/Vue-Filter";
import { mixin } from "@/helpers/Vue-Mixin";
import appConfig from "@/app.config.json";
import Loader from "@/components/widgets/loader.vue";
import Pagination from "@/components/widgets/pagination.vue";
import api from "@/api";
import moment from "moment";

export default {
  filters: {
    ...filter,
  },
  mixins: [mixin],
  page: {
    page: {
      title: "リハビリメニュー",
      meta: [{ name: "description", content: appConfig.description }],
    }
  },
  components: { Loader, Layout, PageHeader, Pagination, CreateRehabModal, DetailRehabModal },
  data() {
    return {
      items: [
        {
          text: "患者一覧",
          href: "/#/hospital/patients",
        },
        {
          text: "リハビリメニュー",
          active: true,
        },
      ],
      loading: true,
      openedCreateRehabModal: false,
      openedDetailRehabModal: false,
      rehabVideoSuggestions: [],
      user: null,
      paging: null,
      selectedId: null,
      reloading: false,
    }
  },
  async created() {
    try {
      await this.getUser();
      await this.getRehabVideoSuggestions();

      this.loading = false;
    } catch (error) {
      console.log(error);
    }
  },
  computed: {
    theme() {
      return this.$store.state.theme;
    },
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    async getUser() {
      const res = await api.getPatientById(this.$route.params.id);

      if (res.status === 200) {
        this.user = res.data;
      }
    },

    async getRehabVideoSuggestions(page = 1) {
      const res = await api.getRehabVideoSuggestions(this.user.id, page);

      if (res.status === 200) {
        this.rehabVideoSuggestions = res.data.data;
        this.paging = res.data.meta;
      }
    },

    async active(id, status) {
      this.confirm(
        {
          title: "",
          html: status ? "処方できるのは１つのみです。<br>このリハビリメニューを処方しますか？" : "このリハビリメニューを解除しますか？",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#395299",
          cancelButtonColor: "#FF5858",
          confirmButtonText: status ? "処方する" : "解除する",
          cancelButtonText: "キャンセル",
          reverseButtons: true,
        },
        async (e) => {
          if (e.isConfirmed) {
            const oldRehabVideoSuggestionId = this.user.rehab_video_suggestion_id
            this.user.rehab_video_suggestion_id = status ? id : null;

            const res = await api.activeRehabVideoSuggestion(id, status);

            if (!res.status === 200) {
              this.user.rehab_video_suggestion_id = oldRehabVideoSuggestionId;
              window.toastr.error("エラーが発生しました。");
            }
          }
        }
      );
    },

    async destroy(id) {
      this.confirm(
        {
          title: "",
          text: "このデータを削除しますか？",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#395299",
          cancelButtonColor: "#FF5858",
          confirmButtonText: "はい",
          cancelButtonText: "いいえ",
          reverseButtons: true,
        },
        async (e) => {
          if (e.isConfirmed) {
            const res = await api.deleteRehabVideoSuggestion(id);

            if (res.status === 200) {
              await this.getRehabVideoSuggestions();
              this.closeDetailRehabModalModal();
            }
          }
        }
      );
    },

    stringDate(stringDate) {
      return moment(stringDate).format('YYYY/MM/DD')
    },

    showCreateRehabModalModal() {
      this.openedCreateRehabModal = true;
    },

    closeCreateRehabModalModal() {
      this.openedCreateRehabModal = false;
    },

    showDetailRehabModalModal(id) {
      this.selectedId = id;
      this.openedDetailRehabModal = true;
    },

    closeDetailRehabModalModal() {
      this.selectedId = null;
      this.openedDetailRehabModal = false;
    },

    async onEditRehabSuggestion(id) {
      this.selectedId = id;
      this.openedCreateRehabModal = true;
    },

    async onUpdated() {
      this.reloading = true;
      await this.getRehabVideoSuggestions();
    },

    async updatedRehab() {
      this.reloading = false;
    },

    async onCreated(rehabVideoSuggestion) {
      await this.getRehabVideoSuggestions();
      this.user.rehab_video_suggestion_id = rehabVideoSuggestion.id;
    },
  }
};
</script>

<template>
  <div :id="theme">
  <Layout>
    <PageHeader :items="items" :theme="theme" />
    <div class="card">
      <Loader :loading="loading">
        <div class="card-body pt-4 pb-3">
          <div class="clearfix">
            <h5 class="text-table float-start">リハビリメニュー</h5>
            <div class="float-end">
              <b-button class="btn btn-lyg text-button btn-secondary px-5 font-weight-semibold"
                @click="showCreateRehabModalModal">リハビリメニュー作成</b-button>
            </div>
          </div>
          <hr class="mb-1" />
        </div>
        <div v-if="rehabVideoSuggestions.length">
          <div class="rehab-item p-3 mb-3" v-for="rehabVideoSuggestion in rehabVideoSuggestions">
            <div style="border: 2px solid #D9D9D9; border-radius: 16px" class="p-3">
              <div class="row align-items-center">
                <div class="col-5">
                  <div class="d-flex flex-row">
                    <div class="d-flex align-items-center flex-shrink-0">
                      <button v-if="rehabVideoSuggestion.id === user.rehab_video_suggestion_id" type="button"
                        @click="active(rehabVideoSuggestion.id, false)" class="btn btn-lyg">処方中</button>
                      <button v-else type="button" @click="active(rehabVideoSuggestion.id, true)"
                        class="btn btn-secondary">選択</button>
                    </div>
                    <div class="ps-3 col-9 col-md-10">
                      <h4 class="font-weight-semibold" style="font-size: 24px">{{ rehabVideoSuggestion.title }}</h4>
                      <div style="font-size: 16px">更新日: {{ stringDate(rehabVideoSuggestion.updated_at) }}</div>
                    </div>
                  </div>
                </div>
                <div class="col-3 col-md-4">
                  <div class="d-flex align-items-center justify-content-start">
                    <h3 style="font-size: 24px"> {{ rehabVideoSuggestion.type_name }}</h3>
                  </div>
                </div>
                <div class="col-4 col-md-3 text-end">
                  <div class="d-flex align-items-center justify-content-end">
                    <div class="d-flex align-items-center flex-shrink-0">
                      <button type="button" @click="onEditRehabSuggestion(rehabVideoSuggestion.id)" class="btn btn-lyg me-1 me-md-2">編集</button>
                      <button type="button" @click="destroy(rehabVideoSuggestion.id)" class="btn btn-danger">削除</button>
                    </div>
                    <div class="ms-md-3 d-inline-block">
                      <a class="pointer" @click="showDetailRehabModalModal(rehabVideoSuggestion.id)">
                        <i class='bx bx-chevron-right text-dark fs-1'></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="text-center pb-3">
            まだメニューがありません。
          </div>
        </div>
        <Pagination :paging="paging" @change="getRehabVideoSuggestions" padding="16px" label="件数:" unitLabel="件"/>
      </Loader>
    </div>
    <CreateRehabModal v-if="openedCreateRehabModal" :user="user" @created="onCreated"
      @updated="onUpdated" @close="closeCreateRehabModalModal" :rehabVideoSuggestionId="selectedId" />

    <DetailRehabModal v-if="openedDetailRehabModal" :rehabVideoSuggestionId="selectedId"
      @close="closeDetailRehabModalModal" @editRehab="onEditRehabSuggestion(selectedId)" :reloading="reloading" @updated="updatedRehab" @deleteRehab="destroy(selectedId)"/>
    <button @click="goBack" class="btn btn-back">
      <i class='bx bx-arrow-back' style="transform: translateX(-4px) translateY(2px);"></i>
    </button>
  </Layout>
  </div>
</template>

<style scoped>
::v-deep .footer {
  position: fixed !important;
  left: 0px;
}

.btn-back {
  position: fixed;
  bottom: 40px;
  right: 20px;
  z-index: 1000;
  background-color: #395299;
  color: #fff;
  padding: 10px 20px;
  border-radius: 70px;
  font-size: 1.2rem;
  width: 50px;
  height: 50px;
}
</style>
